// removed by extract-text-webpack-plugin
module.exports = {"header":"src-pages----index-module---header---2Pp1r","main":"src-pages----index-module---main---2LmOO","footer":"src-pages----index-module---footer---1xH5N"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/index.module.scss
// module id = 435
// module chunks = 35783957827783